import React, { PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  condition?: boolean
  wrapper: (children: React.ReactNode) => React.ReactElement
}

export const ConditionalWrapper: React.FC<Props> = ({ condition, wrapper, children }) => {
  if (condition) {
    return wrapper(children)
  }

  return <>{children}</>
}
